"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsModal = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var PermissionSubjectSearchBar_1 = require("./PermissionSubjectSearchBar");
var PermissionsList_1 = require("./PermissionsList");
var usePermissionDisplayMode_1 = require("./usePermissionDisplayMode");
var usePermissionObject_1 = require("./usePermissionObject");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var shared_styles_1 = require("./shared-styles");
var modalContentStyles = {
    fontSize: 'md',
    height: shared_styles_1.MODAL_HEIGHT,
    maxHeight: shared_styles_1.MODAL_MAX_HEIGHT,
    overflow: 'visible',
};
var modalHeaderStyles = {
    bg: 'inherit',
    borderBottom: '1px solid',
    borderColor: 'gray.200',
    fontWeight: 'normal',
    textAlign: 'left',
};
var PermissionsModalLoadingIndicator = function () {
    var _a = (0, usePermissionObject_1.usePermissionObject)(), objectType = _a.objectType, objectId = _a.objectId;
    var _b = (0, usePermissionsModalContext_1.usePermissionsModalContext)(), useIsMutatingPermissions = _b.useIsMutatingPermissions, useIsFetchingUsersAndTeamsSuggestions = _b.useIsFetchingUsersAndTeamsSuggestions;
    var isMutating = useIsMutatingPermissions(objectType, objectId);
    var isSearching = useIsFetchingUsersAndTeamsSuggestions();
    return isMutating || isSearching ? React.createElement(react_1.Spinner, { ml: 2, size: "sm" }) : null;
};
var PermissionsModalTrigger = function (_a) {
    var trigger = _a.trigger, onOpen = _a.onOpen;
    var TriggerComponent = typeof trigger === 'function' ? trigger() : trigger;
    return React.cloneElement(TriggerComponent, { onClick: onOpen });
};
var PermissionsModalHeader = function (_a) {
    var title = _a.title, inputRef = _a.inputRef;
    var mode = (0, usePermissionDisplayMode_1.usePermissionDisplayMode)();
    return (React.createElement(react_1.ModalHeader, { sx: modalHeaderStyles },
        React.createElement(react_1.Box, { as: "span", fontWeight: "bold" }, title),
        React.createElement(PermissionsModalLoadingIndicator, null),
        React.createElement(react_1.ModalCloseButton, null),
        mode === 'edit' && React.createElement(PermissionSubjectSearchBar_1.PermissionSubjectSearchBar, { inputRef: inputRef })));
};
var PermissionsModal = function (_a) {
    var title = _a.title, trigger = _a.trigger, objectType = _a.objectType, objectId = _a.objectId, mode = _a.mode, context = _a.context;
    var _b = (0, react_1.useDisclosure)(), isOpen = _b.isOpen, onOpen = _b.onOpen, onClose = _b.onClose;
    var initialRef = React.useRef(null);
    return (React.createElement(usePermissionsModalContext_1.PermissionsModalContext.Provider, { value: context },
        React.createElement(usePermissionObject_1.PermissionObjectContext.Provider, { value: {
                objectType: objectType,
                objectId: objectId,
            } },
            React.createElement(usePermissionDisplayMode_1.PermissionDisplayModeContext.Provider, { value: mode },
                React.createElement(PermissionsModalTrigger, { trigger: trigger, onOpen: onOpen }),
                React.createElement(react_1.Modal
                // Chakra maps this id to #chakra-modal-permissions-modal
                , { 
                    // Chakra maps this id to #chakra-modal-permissions-modal
                    id: "permissions-modal", isOpen: isOpen, onClose: onClose, initialFocusRef: initialRef, scrollBehavior: "inside" },
                    React.createElement(react_1.ModalOverlay, null),
                    React.createElement(react_1.ModalContent, __assign({}, modalContentStyles),
                        React.createElement(PermissionsModalHeader, { title: title, inputRef: initialRef }),
                        React.createElement(react_1.ModalBody, null,
                            React.createElement(PermissionsList_1.PermissionsList, null))))))));
};
exports.PermissionsModal = PermissionsModal;
